export const gallerySectionLeakInvestigationAndRemediation =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/5.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/6.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/7.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/8.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/9.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/10.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/11.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/12.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/13.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/14.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/15.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/16.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/17.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/18.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/19.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/20.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/21.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/22.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/23.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/24.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/25.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/26.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/27.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/28.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/29.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/30.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/31.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/32.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/33.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/34.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/35.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/36.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/37.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/38.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00010LeakInvestigationRemediation/39.jpg",
            "rowSpan": 2,
            "colSpan": 2
        }
    ]

}